import { render } from "./ProductReadinessFlag.vue?vue&type=template&id=c82c954a&scoped=true"
import script from "./ProductReadinessFlag.vue?vue&type=script&lang=js"
export * from "./ProductReadinessFlag.vue?vue&type=script&lang=js"

import "./ProductReadinessFlag.vue?vue&type=style&index=0&id=c82c954a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82c954a"]])

export default __exports__